import { useEffect, useMemo, useState } from 'react';
import { ConfigService, sharedApiClient } from '../../fetcher';

const useShouldBundleBloodPressureReadings = () => {
  const [shouldBundle, setShouldBundle] = useState(false);
  const configManager = useMemo(() => new ConfigService(sharedApiClient), []);

  useEffect(() => {
    let cancelled = false;
    configManager
      .fetchConfig()
      .then((data) => {
        if (!cancelled) {
          setShouldBundle(data?.generatorConfig?.shouldBundleBloodPressureReadings === true);
        }
      })
      .catch((error) => {
        console.error('Error loading blood pressure bundling setting:', error);
        if (!cancelled) {
          setShouldBundle(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [configManager]);

  return shouldBundle;
};

export default useShouldBundleBloodPressureReadings;
